<template>
  <page>
    <module title="资金流水" enable-flex>
      <m-search ref="search" @search="searchHandle">
        <m-search-item label="收支单号">
          <c-input name="record_number"></c-input>
        </m-search-item>
        <m-search-item label="业务流水号">
          <c-input name="turnover_number"></c-input>
        </m-search-item>
        <m-search-item label="摘要">
          <c-input name="remark"></c-input>
        </m-search-item>
		<m-search-item label="收支类型">
		  <c-select name="record_type" :options="recordType"></c-select>
		</m-search-item>
		
		<m-search-item label="收付类型">
		  <c-select name="turnover_type" :options="turnoverType"></c-select>
		</m-search-item>
		
		<m-search-item label="业务类型">
		  <c-select name="business_type" :options="businessType"></c-select>
		</m-search-item>
		<m-search-item label="交易时间" colspan="2">
		  <c-datetime start-name="begin_time" end-name="end_time" range></c-datetime>
		</m-search-item>
      </m-search>
      <m-operate>
          <c-button color="m" hollow @click="syncExport()">导出</c-button>
      </m-operate>
      <c-table ref="table" height="grow">
        <c-table-column
        	label="收支记录号"
        	name="record_number"
        	width="140"
        ></c-table-column>
        
        <c-table-column
        	label="交易摘要"
        	name="remark"
        	width="270"
        ></c-table-column>
        
        <c-table-column
        	label="交易时间"
        	name="create_date"
        	width="140"
        ></c-table-column>
        
        <c-table-column
        	label="收支类型"
        	name="record_type"
        	width="70"
        >
        </c-table-column>
        
        <c-table-column
        	label="交易金额"
        	name="money"
        	width="70"
        ></c-table-column>
        
        <c-table-column
        	label="余额"
        	width="80"
        	name="surplus_money"
        ></c-table-column>
        
        <c-table-column
        	label="待结算金额"
        	width="90"
        	name="settle_amount"
        ></c-table-column>
        
        <!-- <c-table-column
        	label="业务流水号"
        	name="turnover_number"
        	width="140"
        ></c-table-column> -->
        
        <c-table-column
        	label="业务单号"
        	name="business_number"
        	width="140"
        ></c-table-column>
        
        <!-- <c-table-column
        	label="收付类型"
        	name="turnover_type"
        	width="70"
        ></c-table-column> -->
        
        <c-table-column
        	label="业务类型"
        	width="90"
        	name="business_type"
        >
        	<template v-slot="{data}">
        		{{businessTypeName[data.business_type]}}
        	</template>
        </c-table-column>

        <c-table-column
            type="button"
            label="操作"
            width="90"
        >
          <template #default="{data}">
            <c-table-button @click="detail(data)">查看明细</c-table-button>
          </template>
        </c-table-column>
      </c-table>
    </module>

    <c-dialog ref="detailDialog" title="流水明细" width="800" height="400" :button="false">
		<c-detail column="2">
			<c-detail-item label="收支记录号" >
				{{detailData.record_number}}
			</c-detail-item>
			<c-detail-item label="交易金额" >
				{{detailData.money}}
			</c-detail-item>
			<c-detail-item label="余额" >
				{{detailData.surplus_money}}
			</c-detail-item>
			<c-detail-item label="待结算金额" >
				{{detailData.settle_amount}}
			</c-detail-item>
			<c-detail-item label="收支类型" >
				{{detailData.record_type}}
			</c-detail-item>
			<c-detail-item label="业务流水号" >
				{{detailData.turnover_number}}
			</c-detail-item>
			<c-detail-item label="业务单号" >
				{{detailData.business_number}}
			</c-detail-item>
			<c-detail-item label="收付类型" >
				{{detailData.turnover_type}}
			</c-detail-item>
			<c-detail-item label="业务类型" >
				{{businessTypeName[detailData.business_type]}}
			</c-detail-item>
			<c-detail-item label="会计科目代码">
				{{detailData.account_code}}
			</c-detail-item>
			<c-detail-item label="会计科目">
				{{detailData.account_title}}
			</c-detail-item>
			<c-detail-item label="交易时间">
				{{detailData.create_date}}
			</c-detail-item>
			<c-detail-item label="交易摘要" colspan="2">
				{{detailData.remark}}
			</c-detail-item>
		</c-detail>
    </c-dialog>
  </page>
</template>

<script>
export default {
  data() {
    return {
        workType:11,
        searchParams:{},
		recordTypeName:{
			'收款': '收款',
			'付款': '付款'
		},
		recordType: [{
				name: '收款',
				value: "收款"
			},{
				name: '付款',
				value: "付款"
			}
		],
		turnoverType: [{
				name: '待结算',
				value: "待结算"
			},{
				name: '结算',
				value: "结算"
			},{
				name: '取消结算',
				value: "取消结算"
			},{
				name: '退款',
				value: "退款"
			},{
				name: '提现',
				value: "提现"
			},{
				name: '补款',
				value: "补款"
			},{
				name: '扣款',
				value: "扣款"
			}
		],
		businessType: [{
			name: '销售订单',
			value: "1"
		},{
			name: '销售退款单',
			value: "2"
		},{
			name: '销售退货单',
			value: "3"
		},{
			name: '资金充值',
			value: "4"
		},{
			name: '资金扣减',
			value: "5"
		},{
			name: '资金提现',
			value: "6"
		}],
		businessTypeName :{
			1:'销售订单',
			2:'销售退款单',
			3:'销售退货单',
			4:'资金充值',
			5:'资金扣减',
			6:'资金提现'
		},
		detailData : {}
    }
  },

  mounted() {
	this.$refs.search.search();
  },

  methods: {
    searchHandle(data) {
      this.$refs.table.load({
        url: '/stationed/account/record/list',
        data
      });
      this.searchParams = data||{};
    },

    detail(data) {
      this.request({
      	url: '/stationed/account/record/detail',
      	data: {id: data.id},
      	loading: true,
      	success: data => {
      		this.detailData = data;
      	}
      });
      this.$refs.detailDialog.open();
    },
    /**同步导出数据**/
    syncExport(){
          this.request({
              url: '/export/url',
              data: Object.assign({
                  work_type: this.workType //业务类型
              },this.searchParams),
              success: data => {
                  this.download({
                      fileName: data.filename,
                      url: data.url,
                      loading: {
                          message: '数据文件生成中...'
                      }
                  })
              }
          });
      }
  }
}
</script>

<style lang="stylus" scoped>
</style>
